module.exports = __webpack_public_path__ + "static/media/tick.4d3424f3.svg";